import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.css'],
})
export class HeroSectionComponent {
  counters = [
    { label: 'CV Created', value: 0, target: 3000 },
    { label: 'Career Coaching', value: 0, target: 5000 },
    { label: 'LinkedIn Optimization', value: 0, target: 500 },
    { label: 'Cover Letter Created', value: 0, target: 500 },
  ];
  constructor(private translate: TranslateService) {}
  ngOnInit(): void {
    this.startCounters();
  }

  startCounters() {
    this.counters.forEach((counter) => {
      let step = Math.ceil(counter.target / 100);
      let interval = setInterval(() => {
        if (counter.value < counter.target) {
          counter.value += step;
        } else {
          counter.value = counter.target;
          clearInterval(interval);
        }
      }, 30);
    });
  }
  formatNumber(value: number): string {
    const formatted = value.toLocaleString();
    if (this.translate.currentLang === 'ar') {
      return formatted.replace(/\d/g, (d) =>
        String.fromCharCode(0x0660 + parseInt(d)),
      );
    }
    return formatted;
  }
}
